<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer023">
<p class="dedication" lang="en-US"><span lang="en-US">“We are stardust</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">We are golden</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">And we’ve got to get ourselves</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">Back to the garden …”</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">—Joni Mitchell, </span><em class="italic" lang="en-US">Woodstocks</em></p>
<br/>
<p class="dedication" lang="en-US"><span lang="en-US">“And those who who seen dancing</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">	were thought to be insane</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">	by those who could not hear the music.”</span></p>
<p class="dedication" lang="en-US"><span lang="en-US">—Friedrich Nietzche</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7bae1b94